import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aaf48f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-infos"
}
const _hoisted_2 = {
  key: 0,
  class: "notification"
}
const _hoisted_3 = { class: "thumb" }
const _hoisted_4 = { class: "perfil-name" }
const _hoisted_5 = { class: "perfil-mail" }
const _hoisted_6 = { class: "ic" }
const _hoisted_7 = { class: "info-text" }
const _hoisted_8 = { class: "perfil-plano" }
const _hoisted_9 = { class: "info-vencimento" }
const _hoisted_10 = { class: "perfil-vencimento" }
const _hoisted_11 = { class: "envelopes" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "envelopes-title" }, " Envelopes ", -1))
const _hoisted_13 = { class: "envelopes-count" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slash" }, "/", -1))
const _hoisted_15 = {
  key: 0,
  innerHTML: '∞'
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "space" })
], -1))
const _hoisted_17 = { class: "whatsapp" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "whatsapp-title" }, " Notificações Whatsapp ", -1))
const _hoisted_19 = { class: "whatsapp-count" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slash" }, "/", -1))
const _hoisted_21 = {
  key: 0,
  innerHTML: '∞'
}
const _hoisted_22 = {
  key: 1,
  class: "btn-manage-account-inactive"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_ThumbPerfil = _resolveComponent("ThumbPerfil")!
  const _component_ContainerOutlined = _resolveComponent("ContainerOutlined")!

  return (_ctx.isHome)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isExceededLimitEnvelope && !_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_a_alert, {
                message: "Atenção, seu limite de envios chegou ao limite. Para continuar enviando mais envelopes, contrate um plano maior acessando a opção [GERENCIAR PLANO].",
                type: "info"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["info-thumb", {'is-exceeded-limit-envelope': _ctx.isExceededLimitEnvelope && !_ctx.isMobile}])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ThumbPerfil, { accountType: _ctx.accountType }, null, 8, ["accountType"])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info-perfil", {'is-exceeded-limit-envelope': _ctx.isExceededLimitEnvelope && !_ctx.isMobile}])
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.accountName), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.accountMail), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info-plan", {'is-exceeded-limit-envelope': _ctx.isExceededLimitEnvelope && !_ctx.isMobile}])
        }, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_ContainerOutlined)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, " Plano " + _toDisplayString(_ctx.accountPlanName), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, " Vencimento: " + _toDisplayString(_ctx.expiredAt), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info-plan-consummation", {'is-exceeded-limit-envelope': _ctx.isExceededLimitEnvelope && !_ctx.isMobile}])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass({'blocked': _ctx.isBlockedAccount})
              }, _toDisplayString(_ctx.envelopesConsummation), 3),
              _hoisted_14,
              (_ctx.envelopesLimit == -1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.isBlockedAccount ? 'blocked' : 'current')
                  }, _toDisplayString(_ctx.envelopesLimit), 3))
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.isBlockedAccount ? 'blocked' : 'current')
              }, _toDisplayString(_ctx.whatsappConsummation), 3),
              _hoisted_20,
              (_ctx.whatsappLimit == -1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({'blocked': _ctx.isBlockedAccount})
                  }, _toDisplayString(_ctx.whatsappLimit), 3))
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["info-manage-account", {'is-exceeded-limit-envelope': _ctx.isExceededLimitEnvelope && !_ctx.isMobile}])
        }, [
          (_ctx.isActionAdminOrSysAdmin)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "btn-manage-account",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePlan()))
              }, " Gerenciar Plano "))
            : (_openBlock(), _createElementBlock("span", _hoisted_22, " Gerenciar Plano "))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}